import React, { useState, useEffect, useCallback, useRef } from "react";
import useAppContext from "../../../utils/Reducers";
import ButtonBar from "../../../components/Layout/ButtonBar";
import SearchBar from "./SearchBar";
import { useAxiosWithAuthorization } from "../../../utils/api";
import { columnLayout } from "./columnLayout";
import { defaultGridProps } from "../../../components/AuiGrid/gridLayout";
import {
  setStorageItem,
  getStorageItem,
} from "../../../hooks/Storage/useLocalStorage";
import moment from "moment";
import AUIGrid from "../../../lib/AuiGrid/AUIGridReact";
import { useInterval } from "../../../utils/validators";
import { ModalConfirm } from "../../../components/Confirm";
import { saveGridCheckData } from "../../../utils/validators";

//전송버튼을 클릭했을경우 함수가 외부에서 호출하여 primaryParameters 아무값도 들어가 있지 않음
//그래서 플래그를 두어 sendCnt값이 변경되면 useEffect에서 검색버튼의 함수를 실행시킴
var sendCnt = 0;

const WeighingResult = (props) => {
  var footerLayout = [
    {
      labelText: "합계",
      positionField: "#base",
    },
    {
      dataField: "plantNm",
      positionField: "plantNm",
      operation: "COUNT",
      formatString: "#,##0",
      style: "aui-grid-my-header-sum-total",
    },
    {
      dataField: "inWeight",
      positionField: "inWeight",
      operation: "SUM",
      formatString: "#,##0",
      style: "aui-grid-my-header-sum-total",
    },
    {
      dataField: "outWeight",
      positionField: "outWeight",
      operation: "SUM",
      formatString: "#,##0",
      style: "aui-grid-my-header-sum-total",
    },
    {
      dataField: "realWeight",
      positionField: "realWeight",
      operation: "SUM",
      formatString: "#,##0",
      style: "aui-grid-my-header-sum-total",
    },
    {
      dataField: "inweight1",
      positionField: "inweight1",
      operation: "SUM",
      formatString: "#,##0",
      style: "aui-grid-my-header-sum-total",
    },
    {
      dataField: "outweight1",
      positionField: "outweight1",
      operation: "SUM",
      formatString: "#,##0",
      style: "aui-grid-my-header-sum-total",
    },
    {
      dataField: "realweight1",
      positionField: "realweight1",
      operation: "SUM",
      formatString: "#,##0",
      style: "aui-grid-my-header-sum-total",
    },
  ];

  const myGrid = useRef();
  const [research, setResearch] = useState(0);

  const {
    store: { userInfo, menuKey },
  } = useAppContext();

  useEffect(() => {
    const auiGrid = myGrid.current;
    auiGrid.resize("100%", 600);
  }, [menuKey]);

  const [searchParameters, setSearchParameters] = useState({
    schPlantCd: userInfo.defaultPlantNo,
    schOdrType: "",
    schVhclNo: "",
    schSwgtDt: moment().format("YYYY-MM-DD"),
    schEwgtDt: moment().format("YYYY-MM-DD"),
  });

  const SEARCH_WEIGHINGRESULT_LIST_URL =
    "/incoming/incomingvehicle/searchWeighingResultList.do";

  const SAVE_WEIGHINGRESULT_REAMARK_URL =
    "/incoming/incomingvehicle/saveWeightingResultRemark.do";

  const [, fetchData] = useAxiosWithAuthorization(
    {
      url: SEARCH_WEIGHINGRESULT_LIST_URL,
    },
    { manual: true }
  );

  //코드 및 그리드 초기화 및 생성
  useEffect(() => {
    if (research !== 0) {
      handleMasterSearch();
    }
  }, [research]);

  useEffect(() => {
    const auiGrid = myGrid.current;

    auiGrid.setFooter(footerLayout);

    //Local Storage에 저장된 그리드 컬럼 정렬정보를 가져옴
    const columnList = getStorageItem(props.menuInfo.menuId, "");
    if (columnList !== "") {
      auiGrid.setColumnOrder(columnList);
    }
    const columnSize = getStorageItem(props.menuInfo.menuId + "_s", "");
    if (columnSize !== "") {
      //Local Storage에 저장된 그리드 컬럼 Width 정보를 가져옴
      auiGrid.setColumnSizeList(columnSize);
    }
    searchTransTotalCount();
  }, []);

  useInterval(() => {
    searchTransTotalCount();
  }, 60000);

  const searchTransTotalCount = async () => {
    const {
      data: { data },
    } = await fetchData({
      url: SEARCH_WEIGHINGRESULT_LIST_URL,
    });

    //console.log(data);
  };

  //그리드 정렬 저장
  const handleGridSorting = useCallback(() => {
    const auiGrid = myGrid.current;
    const items = auiGrid.getColumnInfoList();
    let columnList = [];
    let columnSize = [];
    items.forEach((item) => {
      columnList.push(item.dataField);
      columnSize.push(item.width);
    });
    //console.log(items);
    setStorageItem(props.menuInfo.menuId, columnList);
    setStorageItem(props.menuInfo.menuId + "_s", columnSize);
    ModalConfirm({
      title: "그리드 정렬 저장",
      description: "그리드 정렬을 저장하였습니다. ",
    });
  });

  const handleMasterExcel = useCallback(() => {
    const auiGrid = myGrid.current;
    auiGrid.exportToXlsx({
      fileName: props.menuInfo.menuNmKor + " 리스트",
      exceptColumnFields: auiGrid.getHiddenColumnDataFields(),
    });
  });

  const handleMasterSearch = async () => {
    const auiGrid = myGrid.current;
    auiGrid.showAjaxLoader();
    const {
      data: { data },
    } = await fetchData({
      url: SEARCH_WEIGHINGRESULT_LIST_URL,
      params: searchParameters,
    });
    auiGrid.setGridData(data);
    auiGrid.removeAjaxLoader();
  };

  //그리드 정렬 취소
  const handleGridSortingCancel = useCallback(() => {
    const auiGrid = myGrid.current;
    setStorageItem(props.menuInfo.menuId, "");
    var colLayout = columnLayout();
    auiGrid.changeColumnLayout(colLayout);
    ModalConfirm({
      title: "그리드 정렬 취소",
      description: "그리드 정렬을 취소하였습니다. ",
    });
  });

  const handleMasterSave = async () => {
    if (
      await ModalConfirm({
        title: "저장",
        description: "데이터를 저장하시겠습니까?",
      })
    ) {
      let validator = [];

      const auiGrid = myGrid.current;
      var items = auiGrid.getGridData();

      const addItems = auiGrid.getAddedRowItems();
      const editItems = auiGrid.getEditedRowItems();
      const removeItems = auiGrid.getRemovedItems();
      let param = saveGridCheckData(addItems, editItems, removeItems);

      if (param.length > 0) {
        //console.log(param[0]);
        const {
          data: { data },
        } = await fetchData({
          url: SAVE_WEIGHINGRESULT_REAMARK_URL,
          data: param,
          method: "POST",
        });
        handleMasterSearch();
      } else {
        ModalConfirm({
          title: "필수항목체크",
          description: "저장할 항목이 없습니다. ",
          type: "alert",
        });
      }
    }
  };

  return (
    <>
      <ButtonBar
        menuInfo={props.menuInfo}
        handleMasterSearch={handleMasterSearch}
        handleMasterSave={handleMasterSave}
        handleMasterExcel={handleMasterExcel}
        isGridSort={true}
        handleGridSorting={handleGridSorting}
        handleGridSortingCancel={handleGridSortingCancel}
      />
      <SearchBar
        setSearchParameters={setSearchParameters}
        searchParameters={searchParameters}
      />

      <AUIGrid
        ref={myGrid}
        columnLayout={columnLayout()}
        gridProps={{
          ...defaultGridProps,
          width: "100%",
          height: 600,
          editable: true,
          showFooter: true,
          footerPosition: "top",
        }}
      />
    </>
  );
};

export default WeighingResult;
